import React from "react";
import { render } from "react-dom";
// Import Highcharts
import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts/highstock';
import exportingModule from "highcharts/modules/exporting"
exportingModule(Highcharts)
require("highcharts/modules/export-data.js")(Highcharts);
import { apiEndpoint } from "helpers/url_helper";




class AvgSpeedChart extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      avgSpeed: [],
    }

    this.afterChartCreated = this.afterChartCreated.bind(this);
    this.state = {
      chartOptions: {
        chart: {
          type: "column",
        },
        title: {
          text: ""
        },
        credits: {
          enabled: false
      },
      xAxis: {
        labels: {
          format: "{value:%b %e}"
        },
  
        type: "datetime",
       
      },       
        yAxis: {
          title: {
            text: "Speed"
          }
        }, 
        rangeSelector: {
          selected: 6
      },
        series: [
          {    step: true,
            name: "Average Speed",
            data: this.state.avgSpeed,
           
            color: "#7FC9AA",
              borderRadius:5, 
              dataGrouping: {
                enabled: false
              }
          },
        ],
       // exporting: {
        // showTable: false
        // },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "viewFullscreen",
                       "printChart",
                          "separator",
                          "downloadPNG",
                          "downloadJPEG",
                          "downloadPDF",
                          "downloadSVG",
                          "separator",
                          "downloadCSV",
                          "downloadXLS",
                          //"viewData",
                   ]
            }
          },
          filename:"Average Speed_"+new Date().toLocaleDateString()
        },
           
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 2000
              }
            }
          ]
        }
      }
    };
  }

  afterChartCreated(chart) {
    if (!chart.options.chart.forExport) {
      this.internalChart = chart;
      this.forceUpdate();
    }
  }

  async componentDidUpdate(prevProps) {
    if(prevProps.props!=this.props.props){
      //can't change
     const response = await fetch(apiEndpoint+"/GetAvgSpeedData", {
       
     method: 'POST',
     headers: {
         'Content-Type': 'application/json', 
     },
     body:this.props.props
   });
     console.log(response);
    if(response.body!=null && response !=undefined)
    {
   const data = await response.json();
   var objToArr=JSON.parse( data.avgSpeed);
   const newArrayOfObj = (objToArr).map(({
     "Key": x,
     "Value":y,
     ...rest
   }) => ({
     x,y,
     ...rest
   }));
   this.setState({avgSpeed:newArrayOfObj})
   if(this.internalChart.series!=undefined){
   this.internalChart.series[0].setData(newArrayOfObj);
   }
    }
    }
    
   }
 
   async UNSAFE_componentWillReceiveProps (props) {
     console.log(props.props)
     if(props.props!=undefined){
      // can't change
     const response = await fetch(apiEndpoint+"/GetAvgSpeedData", {
       
         method: 'POST',
         headers: {
             'Content-Type': 'application/json', 
         },
         body:props.props
       });
         console.log(response);
        if(response.body!=null && response.body !=undefined)
        {
       const data = await response.json();
       var objToArr=JSON.parse( data.avgSpeed);
       const newArrayOfObj = (objToArr).map(({
         "Key": x,
         "Value":y,
         ...rest
       }) => ({
         x,y,
         ...rest
       }));
       console.log(newArrayOfObj)
       this.setState({avgSpeed:newArrayOfObj})
       if(this.internalChart.series!=undefined){
       this.internalChart.series[0].setData(newArrayOfObj);
       }
        }
     }
     }

  render() {
    return (
      <HighchartsReact
        style={{ height: "100%" }}
        highcharts={Highcharts}
        options={this.state.chartOptions}
        constructorType={'stockChart'}
        callback={this.afterChartCreated}
      />
    );
  }
}

export default AvgSpeedChart;